$(document).ready(function () {

    $('.searchIcon').click(function(e) {
        e.preventDefault();
        var height = $('header').height();
        $(this).hide();
        $('.mobileSearchForm').addClass('active');
        $('.klevu-fluid').show();
        $('header').addClass('background');
        $('.closeSearch').show();
        $('.mobileSearchForm').css('bottom', '-64px');
        return false;
    });
    $('.closeSearch').click(function(e) {
        e.preventDefault();
        $(this).hide();
        $('.mobileSearchForm').removeClass('active');
        $('.klevu-fluid').hide();
        $('header').removeClass('background');
        $('.searchIcon').show();
        $('.mobileSearchForm').css('bottom', '0px');
        return false;
    });

});